import { observer } from "mobx-react-lite";
import React from "react";
import { Dropdown } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default observer(function InventoryReportsSubMenu() {
  const { t } = useTranslation(["common", "customer"]);

  return (
    <>
      {/* <Dropdown.Item
        className="accordionSubMenuStyling"
        id="inventoryTransaction"
        key={"inventoryTransaction"}
        as={Link}
        to={`/reports/inventoryTransaction`}
        text={t("inv_transactions", { ns: "reports" })}
        icon="exchange"
      /> */}
      <Dropdown.Item
        className="accordionSubMenuStyling"
        id="inventorySalesSummary"
        key={"inventorySalesSummary"}
        as={Link}
        to={`/reports/inventorySalesSummary`}
        text={t("inv_sales_summary", { ns: "reports" })}
        icon="clipboard list"
      />
      <Dropdown.Item
        className="accordionSubMenuStyling"
        id="inventoryRecommended"
        key={"inventoryRecommended"}
        as={Link}
        to={`/reports/inventoryRecommended`}
        text={t("inv_recommended", { ns: "reports" })}
        icon="cart plus"
      />
      <Dropdown.Item
        className="accordionSubMenuStyling"
        id="inventoryPurchases"
        key={"inventoryPurchases"}
        as={Link}
        to={`/reports/inventoryPurchases`}
        text={t("inv_purchases", { ns: "reports" })}
        icon="shopping basket"
      />
      <Dropdown.Item
        className="accordionSubMenuStyling"
        id="inventoryOrderList"
        key={"inventoryOrderList"}
        as={Link}
        to={`/reports/inventoryOrderList`}
        text={t("inv_order_list", { ns: "reports" })}
        icon="bell"
      />
      <Dropdown.Item
        className="accordionSubMenuStyling"
        id="currentInventoryValue"
        key={"currentInventoryValue"}
        as={Link}
        to={`/reports/currentInventoryValue`}
        text={t("current_inv_value", { ns: "reports" })}
        icon="balance scale"
      />
      <Dropdown.Item
        className="accordionSubMenuStyling"
        id="inventoryPhysicalCountSheet"
        key={"inventoryPhysicalCountSheet"}
        as={Link}
        to={`/reports/inventoryPhysicalCountSheet`}
        text={t("count_sheet", { ns: "reports" })}
        icon="check square"
      />
    </>
  );
});
